import { Box, Typography, styled } from "@mui/material";
import { useTranslation } from "react-i18next";

const FeaturesContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "16px",
  width: "100%",
  maxWidth: "1200px",
  margin: "0 auto",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: "12px",
  },
}));

const FeatureCard = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  padding: "30px",
  backgroundColor: "var(--background-tertiary)",
  borderRadius: "32px",
  flex: 1,
  [theme.breakpoints.down("md")]: {
    padding: "20px",
    borderRadius: "24px",
    gap: "16px",
  },
}));

const FeatureTitle = styled(Typography)(({ theme }) => ({
  color: "var(--text-primary)",
  [theme.breakpoints.down("md")]: {
    fontSize: "var(--heading-h4-mobile-font-size)",
    lineHeight: "var(--heading-h4-mobile-line-height)",
  },
}));

const FeatureDescription = styled(Typography)({
  color: "var(--text-secondary)",
});

interface Feature {
  titleKey: string;
  descriptionKey: string;
}

const featureKeys: Feature[] = [
  { titleKey: "features.feature1Title", descriptionKey: "features.feature1Description" },
  { titleKey: "features.feature2Title", descriptionKey: "features.feature2Description" },
  { titleKey: "features.feature3Title", descriptionKey: "features.feature3Description" },
];

export const FeaturesSection = () => {
  const { t } = useTranslation();

  return (
    <FeaturesContainer>
      {featureKeys.map((feature, index) => (
        <FeatureCard key={index}>
          <FeatureTitle variant="h4">{t(feature.titleKey)}</FeatureTitle>
          <FeatureDescription variant="body2">
            {t(feature.descriptionKey)}
          </FeatureDescription>
        </FeatureCard>
      ))}
    </FeaturesContainer>
  );
};
